import React, { useMemo } from 'react';
import { get } from 'lodash';
import { SortOutlinedIcon } from 'tuui';
import { Menu } from 'tuui';
import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { campaignGroupSortFieldsOptions } from '../../../../modules/campaigns/config/campaignGroupSortableFields';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import { useCampaignGroupPickerSorting } from '../../hooks/useCampaignGroupPickerSorting';
import { useNodeWindowOverflow } from '../../hooks/useNodeWindowOverflow';
import { BreadcrumbSortItem } from '../BreadcrumbSortItem/BreadcrumbSortItem';
import { menuConfig } from '../CampaignSorting/CampaignSorting';
import styles from '../CampaignSorting/CampaignSorting.module.scss';

const dropdownRequiredWidth = 180;

const SortIcon = () => <SortOutlinedIcon className={styles['sorting-icon']} />;

const Title = () => (
    <FormattedMessage id="app.breadcrumbs.sort" defaultMessage="Sort" className={styles['sort-title']} />
);

const SortItem = ({ item }) => {
    const { sort } = useCampaignGroupPickerSorting();
    return <BreadcrumbSortItem item={item} sort={sort} />;
};

export const CampaignGroupSorting = ({ sort, onSort }) => {
    const currentSortField = get(sort, '0.field');
    const currentOrderField = get(sort, '0.order');

    const { containerRef, overflowWidth } = useNodeWindowOverflow({
        requiredWidth: dropdownRequiredWidth,
    });

    const handleSorting = (order, field) => {
        if (currentSortField === field && currentOrderField === order) {
            return;
        }
        onSort([{ field, order }]);
    };

    const formattedSortFieldsOptions = useMemo(
        () =>
            campaignGroupSortFieldsOptions.map(field => ({
                label: field.label,
                value: field.value,
                subItems: [
                    {
                        label: (
                            <FormattedMessage id={`app.breadcrumbs.${field.value}.${SORTING_ORDER_TYPES.ASCENDANT}`} />
                        ),
                        value: SORTING_ORDER_TYPES.ASCENDANT,
                    },
                    {
                        label: (
                            <FormattedMessage id={`app.breadcrumbs.${field.value}.${SORTING_ORDER_TYPES.DESCENDANT}`} />
                        ),
                        value: SORTING_ORDER_TYPES.DESCENDANT,
                    },
                ],
            })),
        []
    );
    return (
        <div className={styles['sorting-container']} ref={containerRef}>
            <Menu
                items={formattedSortFieldsOptions}
                onSelect={handleSorting}
                ItemComponent={SortItem}
                MenuButtonComponent={SortIcon}
                TitleComponent={Title}
                direction={overflowWidth ? 'left' : 'right'}
                {...menuConfig}
            />
        </div>
    );
};
